<template>
  <ul class="accordion">
    <slot></slot>
  </ul>
</template>

<script>
  export default {
    name: "Accordion",
    props: {
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        Accordion: {
          count: 0,
          active: "",
          multiple: false
        }
      };
    },
    created() {
      this.Accordion.multiple = this.multiple;
    },
    provide() {
      return {Accordion: this.Accordion};
    }
  };
</script>

<style scoped>
  /* .accordion {
  } */
</style>
